import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d6547d3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-6" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "lead" }, [
  /*#__PURE__*/_createTextVNode(" This is your opportunity to leave feedback. Please follow the steps below. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("For feedback to be considered it must be specific and linked to the items within the body of the report. It will be useful for you to have a copy of the report open when you are completing step 2. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("If you have any questions or queries please call our team, we will be happy to help you. We can be reached on 0208 896 2232 and are available Monday to Friday 9.00am-5.00pm. ")
], -1))
const _hoisted_7 = { class: "lead" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-sm-6" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Step 1 (Mandatory)", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "subtitle" }, "Please enter your details.")
], -1))
const _hoisted_12 = { class: "form-group row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, [
  /*#__PURE__*/_createTextVNode("Please select"),
  /*#__PURE__*/_createElementVNode("span", { class: "red-text" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "* ")
  ])
], -1))
const _hoisted_14 = { class: "col-sm-6" }
const _hoisted_15 = {
  key: 0,
  class: "error-message"
}
const _hoisted_16 = { class: "form-group row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, [
  /*#__PURE__*/_createTextVNode("Your name"),
  /*#__PURE__*/_createElementVNode("span", { class: "red-text" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "* ")
  ])
], -1))
const _hoisted_18 = { class: "col-sm-9" }
const _hoisted_19 = {
  key: 0,
  class: "error-message"
}
const _hoisted_20 = { class: "form-group row" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, [
  /*#__PURE__*/_createTextVNode("Your email"),
  /*#__PURE__*/_createElementVNode("span", { class: "red-text" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "* ")
  ])
], -1))
const _hoisted_22 = { class: "col-sm-9" }
const _hoisted_23 = {
  key: 0,
  class: "error-message"
}
const _hoisted_24 = {
  class: "row",
  style: {"padding-top":"50px"}
}
const _hoisted_25 = { class: "col-sm-12 report-section" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-sm-6" }
const _hoisted_28 = { class: "feedback-half-section" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Step 2", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "subtitle" }, "Please select the item number from the list that you wish to make a comment against")
], -1))
const _hoisted_32 = { class: "col-sm-12" }
const _hoisted_33 = { class: "form-group row" }
const _hoisted_34 = {
  key: 0,
  class: "row feedback-half-section"
}
const _hoisted_35 = { class: "col-sm-12" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("legend", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "subtitle" }, "Please add your comments here, and if you wish to submit a photo please upload it by clicking the photo button below. The photo must be a JPEG format")
  ])
], -1))
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-sm-12 selected-item-table" }
const _hoisted_39 = { class: "table" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      style: {"width":"10%"}
    }, "Ref"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      style: {"width":"15%"}
    }, "Item"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      style: {"width":"25%"}
    }, "Description"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      style: {"width":"10%"}
    }, "Qty"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      style: {"width":"15%"}
    }, "Colour"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      style: {"width":"15%"}
    }, "Condition")
  ])
], -1))
const _hoisted_41 = { scope: "row" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_44 = { class: "row" }
const _hoisted_45 = { class: "col-sm-12" }
const _hoisted_46 = { class: "form-group row" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Comments", -1))
const _hoisted_48 = { class: "col-sm-9" }
const _hoisted_49 = { class: "form-group row" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, null, -1))
const _hoisted_51 = { class: "col-sm-9" }
const _hoisted_52 = { class: "table table-sm table-borderless" }
const _hoisted_53 = { class: "form-group row" }
const _hoisted_54 = { class: "col-sm-9 offset-sm-3" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Save", -1))
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = { class: "col-sm-6" }
const _hoisted_58 = {
  key: 0,
  class: "feedback-half-section jumbotron selected-item-jumbotron"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "subtitle" }, "Commented items")
], -1))
const _hoisted_60 = { class: "table" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      style: {"width":"10%"}
    }, "Ref"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      style: {"width":"14%"}
    }, "Item"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      style: {"width":"26%"}
    }, "Description"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      style: {"width":"30%"}
    }, "Comments"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"20%"} })
  ])
], -1))
const _hoisted_62 = { scope: "row" }
const _hoisted_63 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_64 = ["onClick"]
const _hoisted_65 = ["onClick"]
const _hoisted_66 = {
  class: "row",
  style: {"padding-top":"50px"}
}
const _hoisted_67 = { class: "col-sm-6" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Step 3 (If appropriate)", -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "subtitle" }, "General comments - This should only be used for comments you are unable to assign to a specific item number above. Please leave textbox blank if not needed.")
], -1))
const _hoisted_70 = { class: "form-group row" }
const _hoisted_71 = { class: "col-sm-12" }
const _hoisted_72 = ["maxlength"]
const _hoisted_73 = { style: {"float":"right"} }
const _hoisted_74 = { class: "form-group row" }
const _hoisted_75 = { class: "col-sm-12" }
const _hoisted_76 = { class: "table table-sm table-borderless" }
const _hoisted_77 = { class: "row mb-5" }
const _hoisted_78 = { class: "col-sm-12 report-section" }
const _hoisted_79 = { class: "row" }
const _hoisted_80 = { class: "col-sm-6" }
const _hoisted_81 = { class: "feedback-half-section" }
const _hoisted_82 = { class: "row" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Step 4.", -1))
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "subtitle" }, "Press submit. All your comments will be sent to ACT and we will contact you shortly.")
], -1))
const _hoisted_85 = { class: "col-sm-12" }
const _hoisted_86 = { class: "form-group row" }
const _hoisted_87 = ["disabled"]
const _hoisted_88 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_90 = [
  _hoisted_89
]
const _hoisted_91 = {
  key: 1,
  class: "fas fa-save"
}
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("nav", { class: "navbar fixed-bottom navbar-dark bg-primary" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "container-fluid" }, [
    /*#__PURE__*/_createElementVNode("div", { id: "status-bar-buttons" }),
    /*#__PURE__*/_createElementVNode("div", { id: "status-bar-actions" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "text-light" }, [
        /*#__PURE__*/_createElementVNode("div", {
          class: "btn-group",
          role: "group",
          "aria-label": "Primary Actions"
        })
      ])
    ])
  ])
], -1))
const _hoisted_93 = {
  key: 1,
  class: "row"
}
const _hoisted_94 = { class: "col-8 offset-2" }
const _hoisted_95 = {
  key: 0,
  class: "alert alert-danger text-center"
}
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mt-1 mb-2" }, "Error loading report detail", -1))
const _hoisted_97 = {
  key: 0,
  class: "font-weight-bold"
}

import _ from "lodash";
import _get from "lodash/get";
import moment from "moment";

import { computed, ref, onMounted, inject } from 'vue';
import { useStore } from 'vuex';
import { useToast } from "vue-toastification";
import { useRoute, useRouter } from 'vue-router';
import { Report, OrderedItem, Item, Comments, LandlordComments, TenantComments } from '@/models';
import Photos from '@/components/photo/Photos.vue';
import Swal from 'sweetalert2'

import emailjs from "emailjs-com";
import { init } from "emailjs-com";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportFeedback',
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();
const toasted = useToast();

// Injected properties
const actProperty: any = inject('actProperty');

// Component options
const shareholderOptions: string[] = ['Tenant', 'Landlord'];
const report = computed(() => store.getters['reports/current']);

const getReport = async (id: string): Promise<Report> => {
  return await store.dispatch('reports/getReportUnauthenticated', id);
};

const updateReport = async (): Promise<Report> => {
  return await store.dispatch('reports/updateReportUnauthenticated');
};

const updateReportFeedbackStatus = async (payload: { id: string | undefined; status: string }): Promise<any> => {
  await store.dispatch('reports/updateReportFeedbackStatus', payload);
};

const setReportDeep = async (payload: { path: string; data: any }): Promise<any> => {
  return await store.dispatch('reports/setReportDeep', payload);
};

const generateReportPdfAction = async (report: Report): Promise<any> => {
  return await store.dispatch('reports/generateReportPdf', report);
};

const removeRequest = (id: string): void => {
  store.commit('app/removeRequest', id);
};

const addCommentedItem = (item: OrderedItem): void => {
  store.commit('feedback/addCommentedItem', item);
};

const removeCommentedItem = (shareholdertype: string, itemToDelete: OrderedItem): void => {
  store.commit('feedback/removeCommentedItem', { shareholdertype, itemToDelete });
};

const setCommentedItems = (items: OrderedItem[]): void => {
  store.commit('feedback/setCommentedItems', items);
};

const setCurrentItem = (item: Item): void => {
  store.commit('feedback/setCurrentItem', item);
};

const errorMessage = ref("");
const refReport = ref<string>("");
const success = ref<boolean | null>(null);
const isSaving = ref(false);

const shareholdertypetouched = ref(false);
const nametouched = ref(false);
const emailtouched = ref(false);
const invalidemailmessage = ref("");

const conflictModal = ref(null);

const maxtextlength = ref(250);

const shareholdertype = computed({
  get: () => store.state.feedback.shareholdertype,
  set: (value: string) => { store.commit('feedback/setShareholdertype', value); }
});

const comments = computed({
  get: () => store.state.feedback.comments,
  set: (value: Comments) => { store.commit('feedback/setComments', value); }
});

const currentItem = computed({
  get: () => store.state.feedback.currentItem,
  set: (value: OrderedItem) => {
    // Make sure shareholdertype, name and email has been entered
    shareholdertypetouched.value = true;
    nametouched.value = true;
    emailtouched.value = true;

    if (!shareholderdetailvalid.value) return;

    // isItemPreviouslyCommentedOn and gotoStep3 should be defined elsewhere in your setup function
    if (isItemPreviouslyCommentedOn(value)) {
      // Display toast message
    } else {
      // Find the item and set it
      setCurrentItem(value);
      gotoStep3();
    }
  }
});

const saveCommentedItemAndResetForm = async (item: OrderedItem) => {
  addCommentedItem(item);
  setCurrentItem(new OrderedItem());

  Swal.fire({
    title: "Thanks for your feedback",
    html: `<div class="container"><div class="row"><div class="col-sm-12 text-left">You now have 3 choices.<br /><b>Go to
      Step 2</b> - Add another specific comment<br /><b>Go to Step 3</b> - If
      appropriate, give a general comment<br /><b>Go to Step 4</b> - Submit your
      feedback ending this process</div></div></div>`,
    confirmButtonColor: "#253746",
    width: 599,
  });
};

const removeCommentedItemAndReset = (item: OrderedItem) => {
  // Clear comments and photos if any
  if (shareholdertype.value === "Landlord") {
    item.landlordcomments.comments = "";
    item.landlordcomments.photos = [];
  } else if (shareholdertype.value === "Tenant") {
    item.tenantcomments.comments = "";
    item.tenantcomments.photos = [];
  }

  store.commit('feedback/removeCommentedItem', { shareholdertype: shareholdertype.value, itemtodelete: item });
};

const shareholderdetailvalid = computed((): boolean => {
  if (!shareholdertypeisvalid.value || !nameisvalid.value || !emailisvalid.value)
    return false;
  else return true;
});

const commentedItems = computed({
  get: (): OrderedItem[] => {
    return store.state.feedback.commentedItems;
  },
  set: (commentedItems: OrderedItem[]) => {
    store.state.feedback.commentedItems = commentedItems;
  }
});

const unselectedItems = computed((): OrderedItem[] => {
  let items: OrderedItem[] = [];
  let commentedItems: OrderedItem[] = [];
  if (report.value && report.value.rooms) {
    report.value.rooms.forEach((room, roomindex) => {
      if (room.sections) {
        room.sections.forEach((section, sectionindex) => {
          if (section.types) {
            section.types.forEach((type, typeindex) => {
              if (type.items) {
                type.items.forEach((item, itemindex) => {
                  let orderedItem = new OrderedItem(item);
                  orderedItem.roomname = room.name;
                  orderedItem.roomindex = roomindex;
                  orderedItem.section = section.name;
                  orderedItem.sectionindex = sectionindex;
                  orderedItem.type = type.name;
                  orderedItem.typeindex = typeindex;
                  orderedItem.item = item;
                  orderedItem.itemindex = itemindex;
                  items.push(orderedItem);
                });
              }
            });
          }
        });
      }
    });
  }

  const orderedlist = items.map((item, order) => {
    item.order = order + 1;
    return item;
  });
  if (store.state.feedback.step == "step3") {
    orderedlist.forEach((ordereditem) => {
      // If this item is in the commented list
      // Update that
      if (
        store.state.feedback.commentedItems &&
        store.state.feedback.commentedItems.length
      ) {
        const commenteditems = store.state.feedback.commentedItems.filter(
          (citem) => citem.order == ordereditem.order
        );
        if (commenteditems && commenteditems.length) {
          const commenteditem = commenteditems[0];
          commenteditem._uuid = ordereditem._uuid;
          if (shareholdertype.value == "Landlord") {
            commenteditem.landlordcomments.photos =
              ordereditem.landlordcomments.photos;
          } else if (shareholdertype.value == "Tenant") {
            commenteditem.tenantcomments.photos =
              ordereditem.tenantcomments.photos;
          }
        }
      }
    });
  }
  return orderedlist;
});

const shareholdertypeisvalid = computed((): boolean => {
  let valid = true;
  if (emailtouched.value) {
    valid = !!shareholdertype.value;
  }
  return valid;
});

const shareholdername = computed({
  get: (): string => {
    let name = "";
    if (shareholdertype.value == "Landlord") {
      name = store.state.feedback.landlordcommentsname;
    } else if (shareholdertype.value == "Tenant") {
      name = store.state.feedback.tenantcommentsname;
    }
    return name;
  },
  set: (data: string) => {
    if (shareholdertype.value == "Landlord") {
      store.state.feedback.landlordcommentsname = data;
      setReportDeep({ path: "landlordcommentsname", data });
    } else if (shareholdertype.value == "Tenant") {
      store.state.feedback.tenantcommentsname = data;
      setReportDeep({ path: "tenantcommentsname", data });
    }
  }
});

const nameisvalid = computed((): boolean => {
  let valid = true;
  if (nametouched.value) {
    if (shareholdertype.value == "Landlord") {
      valid = !!store.state.feedback.landlordcommentsname;
    } else if (shareholdertype.value == "Tenant") {
      valid = !!store.state.feedback.tenantcommentsname;
    } else {
      valid = false;
    }
  }
  return valid;
});

const shareholderemail = computed({
  get: (): string => {
    let email = "";
    if (shareholdertype.value == "Landlord") {
      email = store.state.feedback.landlordcommentsemail;
    } else if (shareholdertype.value == "Tenant") {
      email = store.state.feedback.tenantcommentsemail;
    }
    return email;
  },
  set: (data: string) => {
    if (shareholdertype.value == "Landlord") {
      store.state.feedback.landlordcommentsemail = data;
      setReportDeep({ path: "landlordcommentsemail", data });
    } else if (shareholdertype.value == "Tenant") {
      store.state.feedback.tenantcommentsemail = data;
      setReportDeep({ path: "tenantcommentsemail", data });
    }
  }
});

const emailisvalid = computed((): boolean => {
  let result = true;
  if (emailtouched.value) {
    let present = true;
    if (shareholdertype.value == "Landlord") {
      present = !!store.state.feedback.landlordcommentsemail;
    } else if (shareholdertype.value == "Tenant") {
      present = !!store.state.feedback.tenantcommentsemail;
    }

    if (!present) {
      invalidemailmessage.value = "Email is required";
      result = false;
    } else {
      let valid = validateEmail(shareholderemail.value);
      if (!valid) {
        result = false;
        invalidemailmessage.value = "Invalid email address";
      } else {
        result = true;
        invalidemailmessage.value = "";
      }
    }
  }
  return result;
});

const validateEmail = (email: string) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(String(email).toLowerCase());
}

const setShareholdertypetouched = () => {
  shareholdertypetouched.value = true;
}
const setNametouched = () => {
  nametouched.value = true;
}
const setEmailtouched = () => {
  emailtouched.value = true;
}

// Lifecycle hooks
onMounted(async () => {
  refReport.value = route.params.ref as string;
  await initialise();
});

const initialise = async () =>  {
  // initialise email service
  init("user_bxsrHY1JcetciJlEtXpDb");
  store.state.feedback.step = "step1";
  await getReport(refReport.value)
    .then((report: Report) => {
      if (report === undefined) {
        success.value = false;
        router.push({ name: "reportnotfound" });
      } else {
        // Check if report is within the days limit
        // Check if the feedback link is active
        // Update feedbackstatus to Opened
        if(report.feedbackstatus === ''){
          updateReportFeedbackStatus({ id: report.id, status: 'Opened' });
        }
        let exp_date_string = report.exportedAt;
        if (!exp_date_string) {
          exp_date_string = report.date;
        }
        let feedback_date = undefined;
        if (exp_date_string) {
          feedback_date = moment(
            exp_date_string,
            "YYYY-MM-DD[T]HH:mm"
          ).toDate();
        }

        const date1: any = moment(feedback_date, "YYYY-MM-DD").startOf("day");
        const date2: any = moment(new Date(), "YYYY-MM-DD").startOf("day");
        const diffTime = Math.abs(date2 - date1);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        const feedbackActive =
          "checkout" != report.type &&
          report.customer &&
          report.customer.feedbacklinkactive &&
          report.customer.feedbacklinkactivedays &&
          diffDays <= report.customer.feedbacklinkactivedays;

        if (feedbackActive) {
          success.value = true;
        } else {
          success.value = false;
          router.push({ name: "feedbacklock" });
        }
      }
    })
    .catch((err: any) => {
      success.value = false;
      router.push({ name: "reportnotfound" });
    });
}

/**
 * Generate INV/CI/CO Report PDF
 */
const generateReportPdf = (report: Report, requestId: any): void => {
  generateReportPdfAction(report)
    .then((key: string) => {
      actProperty.downloadAttachment(key);
      toasted.success(`Report ${report.ref} PDF downloaded`);
    })
    .finally(() => removeRequest(requestId))
    .catch((err: any) => actProperty.displayError(err));
}

const gotoStep2 = () => {
  shareholdertypetouched.value = true;
  nametouched.value = true;
  emailtouched.value = true;

  if (shareholderdetailvalid.value) {
    store.commit('feedback/setStep', 'step2'); // Assuming you have a mutation for setting step

    // Clear previously entered general comments and photographs
    const currentReport = store.state.reports.current; // Accessing the current report
    if (currentReport && currentReport.comments) {
      if (shareholdertype.value === "Landlord") {
        currentReport.comments.client = "";
        currentReport.comments.clientPhotos = [];
      } else if (shareholdertype.value === "Tenant") {
        currentReport.comments.tenant = "";
        currentReport.comments.tenantPhotos = [];
      }
    }
  }
};

const gotoStep3 = () => {
  store.commit('feedback/setStep', 'step3'); // Assuming you have a mutation for setting step

  // Clear previously entered comments and photographs from selected item
  const currentItem = store.state.feedback.currentItem;
  if (!isItemAlreadyCommentedOn(currentItem)) {
    if (shareholdertype.value === "Landlord") {
      currentItem.landlordcomments = new LandlordComments();
      currentItem.item.landlordcomments.photos = [];
    } else if (shareholdertype.value === "Tenant") {
      currentItem.tenantcomments = new TenantComments();
      currentItem.item.tenantcomments.photos = [];
    }
  }
};

const addressPreviewLine1 = () => {
  const line1 = store.state.reports.current.address.line1;
  return `${line1}${line1 ? "," : ""}`;
};

const addressPreviewLine2 = () => {
  return store.state.reports.current.address.postcode;
};

const itemLabel = (item: OrderedItem) => {
  return item && item.order
    ? `${item.order} - ${item.roomname} - ${item.section} - ${item.type} - ${item.name}`
    : "";
};

const itemcomments = computed({
  get: () => {
    const currentItem = store.state.feedback.currentItem;

    if (shareholdertype.value === "Landlord") {
      return currentItem.landlordcomments.comments;
    } else if (shareholdertype.value === "Tenant") {
      return currentItem.tenantcomments.comments;
    }

    return null;
  },
  set: (data) => {
    const currentItem = store.state.feedback.currentItem;

    if (shareholdertype.value === "Landlord") {
      currentItem.landlordcomments.comments = data;
    } else if (shareholdertype.value === "Tenant") {
      currentItem.tenantcomments.comments = data;
    }
  }
});

const getItemcomments = (item: OrderedItem): string | null => {
  if (shareholdertype.value === "Landlord") {
    return item.landlordcomments.comments;
  } else if (shareholdertype.value === "Tenant") {
    return item.tenantcomments.comments;
  }

  return null;
};

const getCommentsPhotoPath = (item: OrderedItem): string => {  
  if (shareholdertype.value === "Landlord") {
    return `rooms[${item.roomindex}].sections[${item.sectionindex}].types[${item.typeindex}].items[${item.itemindex}].landlordcomments.photos`;
  } else if (shareholdertype.value === "Tenant") {
    return `rooms[${item.roomindex}].sections[${item.sectionindex}].types[${item.typeindex}].items[${item.itemindex}].tenantcomments.photos`;
  }

  return "";
};

const getCommentsPhotos = (item: Item): any[] => {
  if (shareholdertype.value === "Landlord") {
    return _get(item, "landlordcomments.photos", []);
  } else if (shareholdertype.value === "Tenant") {
    return _get(item, "tenantcomments.photos", []);
  }

  return [];
};

const getCommentsPhotosLength = (item: Item): number => {
  let arr = getCommentsPhotos(item);
  return arr.length;
}

const getCommentsPhotoButtonLabel = (item: Item): string => {
  const photos = getCommentsPhotos(item);
  return photos && photos.length ? "Add another photo" : "Add photo";
};

const photosPresent = (item: Item): boolean => {
  const photos = getCommentsPhotos(item);
  return photos && photos.length > 0;
};

const generalcomments = computed({
  get: () => {
    const feedbackComments = store.state.feedback.comments;

    if (shareholdertype.value === "Landlord") {
      return feedbackComments.client;
    } else if (shareholdertype.value === "Tenant") {
      return feedbackComments.tenant;
    }

    return "";
  },
  set: (data) => {
    if (shareholdertype.value === "Landlord") {
      store.state.feedback.comments.client = data;
    } else if (shareholdertype.value === "Tenant") {
      store.state.feedback.comments.tenant = data;
    }
  }
});

const getGeneralCommentsPhotoPath = (report: Report): string => {
  if (shareholdertype.value === "Landlord") {
    return `localcomments.clientPhotos`;
  } else if (shareholdertype.value === "Tenant") {
    return `localcomments.tenantPhotos`;
  }

  return "";
}

const getGeneralCommentsPhotos = (report: Report): any[] => {
  if (shareholdertype.value === "Landlord") {
    return _get(report, "localcomments.clientPhotos", []);
  } else if (shareholdertype.value === "Tenant") {
    return _get(report, "localcomments.tenantPhotos", []);
  }

  return [];
};

const getGeneralCommentsPhotosKey = (report: Report): any => {
  let arr = getGeneralCommentsPhotos(report);
  return `${arr.length}-${shareholdertype.value}`;
}

const getGeneralCommentsPhotoButtonLabel = (report: Report): string => {
  const photos = getGeneralCommentsPhotos(report);
  return photos && photos.length ? "Add another photo" : "Add photo";
};

const defaultReportTitle = (): string => {
  const reportType = store.state.reports.current.type;
  const dictionary = store.state.dictionary; // Assuming dictionary is in the store
  // Replace with appropriate method to format report type
  return actProperty.formatReportType(reportType, dictionary);
};

const isItemAlreadyCommentedOn = (itemToCheck: OrderedItem): boolean => {
  const commentedItems = store.state.feedback.commentedItems;
  return commentedItems.some((item) => item.order === itemToCheck.order);
};

const isItemPreviouslyCommentedOn = (itemToCheck: OrderedItem): boolean => {
  const currentlyCommented = isItemAlreadyCommentedOn(itemToCheck);
  if (!currentlyCommented) {
    const currentComments = getItemcomments(itemToCheck); // Assuming getItemcomments is defined
    const photos = getCommentsPhotos(itemToCheck); // Assuming getCommentsPhotos is defined
    return !!currentComments || (photos && photos.length > 0);
  }
  return false;
};

const saveAll = () => {
  // Make sure shareholdertype, name and email has been entered
  shareholdertypetouched.value = true;
  nametouched.value = true;
  emailtouched.value = true;
  if (!shareholderdetailvalid.value) return;

  // Move across all the unsaved changes from feedback to the current report
  if (
    shareholdertype.value == "Landlord" &&
    store.state.feedback.comments.client
  ) {
    let data = `${report.value.comments.client}\n${store.state.feedback.comments.client}`;
    setReportDeep({ path: "comments.client", data });
  } else if (
    shareholdertype.value == "Tenant" &&
    store.state.feedback.comments.tenant
  ) {
    let data = `${report.value.comments.tenant}\n${store.state.feedback.comments.tenant}`;
    setReportDeep({ path: "comments.tenant", data });
  }

  if (
    shareholdertype.value == "Landlord" &&
    report.value.localcomments.clientPhotos &&
    report.value.localcomments.clientPhotos.length
  ) {
    report.value.comments.clientPhotos =
      report.value.localcomments.clientPhotos;
  } else if (
    shareholdertype.value == "Tenant" &&
    report.value.localcomments.tenantPhotos &&
    report.value.localcomments.tenantPhotos.length
  ) {
    report.value.comments.tenantPhotos =
      report.value.localcomments.tenantPhotos;
  }

  if (commentedItems.value.length) {
    commentedItems.value.forEach((item) => {
      item.saveChangesToReportItem();
    });
  }

  toasted.warning(`Saving`);
  isSaving.value = true;
  updateReport()
    .then((report: Report) => {
      updateReportFeedbackStatus({ id: report.id, status: 'Received' });  
      isSaving.value = false;
      toasted.success(`Saved`);
      notifybackoffice();
      notifylltt();
      router.push({ name: "feedbacksuccess" });
    })
    .catch((err: any) => {
      // Check for 409 Conflict
      if (_.get(err, "response.data.statusCode") === 409) {
        const modal = conflictModal.value as any;
        modal.show();
      } else {
        actProperty.displayError(err);
      }
      isSaving.value = false;
    });
}

const notifybackoffice = async () => {
  try {
    const reportRef = store.state.reports.current.ref;
    await emailjs.send("service_4lk4hif", "template_1tyedx7", {
      ref: refReport.value,
      lltt: shareholdertype.value,
      reportref: reportRef,
      address: `${addressPreviewLine1()} ${addressPreviewLine2()}`,
      llttname: shareholdername.value,
      reporturl: `https://${window.location.hostname}/reports/${refReport.value}/comments`,
    });
  } catch (error) {
    console.log({ error });
  }
};

const notifylltt = async () => {
  try {
    const namesplits = shareholdername.value.split(" ");
    const llttname = namesplits.length > 0 ? namesplits[0] : shareholdername.value;

    await emailjs.send("service_4lk4hif", "template_guas2ag", {
      lltt: shareholdertype.value,
      ref: refReport.value,
      address: `${addressPreviewLine1()} ${addressPreviewLine2()}`,
      llttname: llttname,
      llttemail: shareholderemail.value,
    });
  } catch (error) {
    console.log({ error });
  }
};



// ... other component options and methods

return (_ctx: any,_cache: any) => {
  const _component_singleselect_text = _resolveComponent("singleselect-text")!
  const _component_singleselect_number = _resolveComponent("singleselect-number")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (success.value === true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h1", null, [
                _createTextVNode(_toDisplayString(addressPreviewLine1()), 1),
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString(addressPreviewLine2()), 1)
              ]),
              _hoisted_6,
              _createElementVNode("p", _hoisted_7, [
                _createTextVNode(" To download PDF copy of the report. Please click "),
                _createElementVNode("a", {
                  href: "#",
                  class: "bluelink",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (generateReportPdf(report.value, $event)))
                }, "here"),
                _createTextVNode(". ")
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("form", null, [
                _hoisted_10,
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_singleselect_text, {
                      modelValue: shareholdertype.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((shareholdertype).value = $event)),
                      value: shareholdertype.value,
                      options: shareholderOptions,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (setShareholdertypetouched()))
                    }, null, 8, ["modelValue", "value"]),
                    (!shareholdertypeisvalid.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_15, " Type is required "))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((shareholdername).value = $event)),
                      onBlur: _cache[4] || (_cache[4] = ($event: any) => (setNametouched()))
                    }, null, 544), [
                      [
                        _vModelText,
                        shareholdername.value,
                        void 0,
                        { lazy: true }
                      ]
                    ]),
                    (!nameisvalid.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_19, " Name is required "))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("div", _hoisted_22, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((shareholderemail).value = $event)),
                      onBlur: _cache[6] || (_cache[6] = ($event: any) => (setEmailtouched()))
                    }, null, 544), [
                      [
                        _vModelText,
                        shareholderemail.value,
                        void 0,
                        { lazy: true }
                      ]
                    ]),
                    (!emailisvalid.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(invalidemailmessage.value), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _hoisted_31,
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _createVNode(_component_singleselect_number, {
                            modelValue: currentItem.value,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((currentItem).value = $event)),
                            options: unselectedItems.value,
                            "custom-label": itemLabel,
                            label: "order"
                          }, {
                            singleLabel: _withCtx((props) => [
                              _createElementVNode("span", null, _toDisplayString(itemLabel(props.option)), 1)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "options"])
                        ])
                      ])
                    ])
                  ]),
                  (currentItem.value && currentItem.value.order)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _hoisted_36,
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("div", _hoisted_38, [
                              _createElementVNode("table", _hoisted_39, [
                                _hoisted_40,
                                _createElementVNode("tbody", null, [
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("th", _hoisted_41, _toDisplayString(currentItem.value.order), 1),
                                    _createElementVNode("td", null, _toDisplayString(currentItem.value.roomname), 1),
                                    _createElementVNode("td", null, _toDisplayString(currentItem.value.name), 1),
                                    _createElementVNode("td", null, [
                                      (currentItem.value.qty)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(currentItem.value.qty), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("td", null, _toDisplayString(currentItem.value.colour), 1),
                                    _createElementVNode("td", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentItem.value.condition.in.notes, (note) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: note.id
                                        }, [
                                          _createTextVNode(_toDisplayString(note.note), 1),
                                          _hoisted_43
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("div", _hoisted_45, [
                              _createElementVNode("fieldset", null, [
                                _createElementVNode("div", _hoisted_46, [
                                  _hoisted_47,
                                  _createElementVNode("div", _hoisted_48, [
                                    _withDirectives(_createElementVNode("textarea", {
                                      class: "form-control",
                                      rows: "10",
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((itemcomments).value = $event))
                                    }, null, 512), [
                                      [
                                        _vModelText,
                                        itemcomments.value,
                                        void 0,
                                        { lazy: true }
                                      ]
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_49, [
                                  _hoisted_50,
                                  _createElementVNode("div", _hoisted_51, [
                                    _createElementVNode("table", _hoisted_52, [
                                      (_openBlock(), _createBlock(Photos, {
                                        key: getCommentsPhotosLength(currentItem.value.item),
                                        photos: getCommentsPhotos(currentItem.value.item),
                                        path: getCommentsPhotoPath(currentItem.value),
                                        buttontext: 
                                  getCommentsPhotoButtonLabel(currentItem.value.item)
                                
                                      }, null, 8, ["photos", "path", "buttontext"]))
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_53, [
                                  _createElementVNode("div", _hoisted_54, [
                                    _createElementVNode("button", {
                                      class: "btn btn-primary",
                                      onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (
                                saveCommentedItemAndResetForm(currentItem.value)
                              ), ["prevent"]))
                                    }, _hoisted_56)
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_57, [
                  (commentedItems.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                        _hoisted_59,
                        _createElementVNode("table", _hoisted_60, [
                          _hoisted_61,
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(commentedItems.value, (item) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: item._uuid
                              }, [
                                _createElementVNode("th", _hoisted_62, _toDisplayString(item.order), 1),
                                _createElementVNode("td", null, _toDisplayString(item.roomname), 1),
                                _createElementVNode("td", null, _toDisplayString(item.name), 1),
                                _createElementVNode("td", null, _toDisplayString(getItemcomments(item)), 1),
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_63, [
                                    _createElementVNode("button", {
                                      class: "btn btn-sm btn-primary",
                                      onClick: _withModifiers(($event: any) => (setCurrentItem(item)), ["prevent"])
                                    }, " Edit ", 8, _hoisted_64),
                                    _createElementVNode("button", {
                                      class: "btn btn-sm btn-primary",
                                      onClick: _withModifiers(($event: any) => (removeCommentedItem(shareholdertype.value, item)), ["prevent"])
                                    }, " Delete ", 8, _hoisted_65)
                                  ])
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_66, [
            _createElementVNode("div", _hoisted_67, [
              _createElementVNode("fieldset", null, [
                _hoisted_68,
                _hoisted_69,
                _createElementVNode("div", _hoisted_70, [
                  _createElementVNode("div", _hoisted_71, [
                    _withDirectives(_createElementVNode("textarea", {
                      class: "form-control",
                      rows: "10",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((generalcomments).value = $event)),
                      maxlength: maxtextlength.value
                    }, null, 8, _hoisted_72), [
                      [_vModelText, generalcomments.value]
                    ]),
                    _createElementVNode("div", _hoisted_73, " Remaining characters : " + _toDisplayString(maxtextlength.value - generalcomments.value.length), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("div", _hoisted_75, [
                    _createElementVNode("table", _hoisted_76, [
                      (_openBlock(), _createBlock(Photos, {
                        key: getGeneralCommentsPhotosKey(report.value),
                        photos: getGeneralCommentsPhotos(report.value),
                        path: getGeneralCommentsPhotoPath(report.value),
                        buttontext: getGeneralCommentsPhotoButtonLabel(report.value)
                      }, null, 8, ["photos", "path", "buttontext"]))
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_77, [
            _createElementVNode("div", _hoisted_78, [
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("div", _hoisted_80, [
                  _createElementVNode("div", _hoisted_81, [
                    _createElementVNode("div", _hoisted_82, [
                      _hoisted_83,
                      _hoisted_84,
                      _createElementVNode("div", _hoisted_85, [
                        _createElementVNode("div", _hoisted_86, [
                          _createElementVNode("button", {
                            class: "btn btn-danger btn-lg btn-block",
                            onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (saveAll()), ["prevent"])),
                            disabled: isSaving.value
                          }, [
                            (isSaving.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_88, _hoisted_90))
                              : (_openBlock(), _createElementBlock("i", _hoisted_91)),
                            _createTextVNode(" Submit all comments to ACT, finalising the feedback process ")
                          ], 8, _hoisted_87)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_92
        ]))
      : _createCommentVNode("", true),
    (success.value === false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
          _createElementVNode("div", _hoisted_94, [
            (success.value === false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                  _hoisted_96,
                  (errorMessage.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_97, _toDisplayString(errorMessage.value), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})